import React from 'react';
import { Operator } from 'mapistry-shared';
import { SelectableOption } from '@monorepo/shared/types/SelectableOption';
import { DateFilterCondition } from './DateFilterCondition';

const dateRangeOperatorOptions: SelectableOption<Operator>[] = [
  { label: 'Is empty', value: Operator.EMPTY },
  { label: 'Is not empty', value: Operator.NOT_EMPTY },
  { label: 'Is before', value: Operator.BEFORE },
  { label: 'Is equal or before', value: Operator.EQUAL_OR_BEFORE },
  { label: 'Is after', value: Operator.AFTER },
  { label: 'Is equal or after', value: Operator.EQUAL_OR_AFTER },
  { label: 'Has no start date', value: Operator.RANGE_HAS_NO_START },
  { label: 'Has no end date', value: Operator.RANGE_HAS_NO_END },
  { label: 'Includes date', value: Operator.RANGE_CONTAINS_DATE },
];

export function DateRangeFilterCondition({ name }: { name: string }) {
  return (
    <DateFilterCondition
      name={name}
      operatorOptions={dateRangeOperatorOptions}
    />
  );
}
